<template lang="pug">
  input.form-control(
    v-if="dataType === 'number'"
    v-model.number="currentValue"
    type="number"
    :disabled="disabled"
    :id="'form-'+name"
    :placeholder="placeholder")
  input.form-control(
    v-else-if="dt === 'focus'"
    v-model="currentValue"
    type="text"
    :disabled="disabled"
    :id="'form-'+name"
    :placeholder="placeholder"
    @click="mapShow")
  input.form-control(
    v-else
    v-model="currentValue"
    type="text"
    :disabled="disabled"
    :id="'form-'+name"
    :placeholder="placeholder")
</template>

<script>
import { dataTypeFunc } from '@/utils/common'

export default {
  name: 'SmartFormInput',
  props: {
    name: String,
    propType: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String | Number
    },
    dataType: {
      type: String,
      default: 'string'
    },
    dt: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentValue: {
      get () {
        return this.value
      },
      set (val) {
        // if (this.dataType === 'number') {
        //   val = val.replace(/[^\d]/g, '')
        // }
        this.$emit('input', dataTypeFunc(val, this.dataType))
      }
    },
    inputType () {
      return this.propType
    }
  },
  methods: {
    mapShow () {
      this.$emit('SmartInput')
    }
  }
}
</script>




// WEBPACK FOOTER //
// SmartInput.vue?5e0a7e33